import { toRef, computed } from 'vue';
import { useGlobalStore } from '@/stores/globalStore';

const checkGeo = (countryCode) => {
  const globalStore = useGlobalStore();
  if (!globalStore.global.detectedGeo) { return false; }
  const detectedGeo = toRef(globalStore.global.detectedGeo.country_code, 'detectedGeo');
  const isGeoMatching = computed(() => detectedGeo.value === countryCode);
  return isGeoMatching.value;
};

export { checkGeo };
